export default __webpack_public_path__ + "static/media/bannerSmall7.35ca75d9.png";